const initialState = {
  useHighContrast: JSON.parse(localStorage.getItem('useHighContrast')),
};

const settings = (state = initialState, { type }) => {
  switch (type) {
    case 'TOGGLE_CONTRAST':
      return {
        ...state,
        useHighContrast: !state.useHighContrast,
      };
    default:
      return state;
  }
};

export default settings;



// WEBPACK FOOTER //
// ./client/app/reducers/settings.js